<template>
    <div class="p-3">
        <filtro ref="filtro" @buscar="buscar" v-show="!dashboard"/>
        <div>
            <VueApexCharts type="line" :options="chartOptions" :series="series"></VueApexCharts>                       
        </div>  
    </div>
</template>
<script>
import MovimentacaoFinanceiraService from "@/common/services/movimentacao_financeira/movimentacao_financeira.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import {FormMixin} from "@/common/mixins/FormMixin";
import Filtro from "../Filtro";
import VueApexCharts from 'vue-apexcharts'
import helpers from "../../../../common/utils/helpers";
export default {
    mixins: [AlertasMixin, FormMixin],
    components: {
        VueApexCharts,
        Filtro
    },
    props: {
        empresaId: {
            type: String,
            required: true
        },
        dashboard : {
            type : Boolean,
            default : false
        }
    },
    data: () => ({
        dados : [], 
        chartOptions: {},
    }),
    methods : {
        montar : function(){
            this.$refs['filtro'].montar();
        },

        buscar : function(filtro){
            this.$store.dispatch(START_LOADING);
            MovimentacaoFinanceiraService.listarGrafico(this.empresaId, filtro.ano, filtro.anoFim, filtro.mesInicio, filtro.mesFim).then(response => {
                this.dados = response.data.data;
                
            }).catch(() => {
                this.alertaErro("Erro ao buscar");
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
    },
    watch : {
        dados : {
            handler(){
                this.chartOptions = {
                    chart: {
                        height: 350,
                        type: 'line',
                        zoom: {
                            enabled: false
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    markers: {
                        size: 7,
                    },
                    xaxis : {
                        categories : this.dados? this.dados.map(el => {return `${el.mes == 'Marco' ? 'Março' : el.mes}/${el.ano}`; }) : []
                    },
                    yaxis : {
                        labels : {
                            formatter: function(val) {
                                return helpers.formatarValor(val);
                            }
                        },
                    }
                };
            },
            deep : true,
            immediate : true
        }
    },
    computed : {
        series: function() {
            return [
                {
                    name: 'Saldo em conta P&D(com SELIC)',
                    data: this.dados ? this.dados.map(el => el.saldoPDSelic.toFixed(2)) : []
                },
                {
                    name: 'Montante acumulado nos últimos 2 anos',
                    data: this.dados? this.dados.map(el => el.saldoAcumulado2Anos.toFixed(2)) : []
                }
            ];
        } 
    }
}
</script>
<style lang="">
    
</style>